<mat-card class="cardWithShadow card-profile">
  <mat-card-content class="p-y-24">
    <mat-card-title>{{ "profile_image.change_profile" | translate }}</mat-card-title>
    <mat-card-subtitle class="f-s-14">{{ "profile_image.change_picture_profile" | translate }}</mat-card-subtitle>
    <div class="text-center m-t-24">
      <div [style.backgroundImage]="'url(' + avatar + ')'" class="rounded-circle align-items-lg-center" style="width: 120px; height: 120px; background-size: cover; margin: auto;"></div>
      <form [formGroup]="profileForm" (ngSubmit)="onSubmit()">
        <div class="m-t-24">
        <div class="m-b-8 m-r-8 mdc-button mdc-button--unelevated mat-mdc-unelevated-button mat-mdc-button-touch-target mat-primary mat-mdc-button-base mat-focus-indicator">
          {{ "profile_image.choose_file" | translate }}
          <input type="file" accept="image/png,image/jpeg,image/jpg" class="file-input" (change)="onFileSelected($event)" #fileInput>
        </div>
          <mat-error *ngIf="profileForm.get('avatar')?.hasError('invalidFileType')">
            {{ "profile_image.invalid_file_type" | translate }} (JPG, GIF, PNG)
          </mat-error>
          <mat-error *ngIf="profileForm.get('avatar')?.hasError('invalidFileSize')">
            {{ "profile_image.file_too_large" | translate }} (Max 800KB)
          </mat-error>
        </div>
        <div class="m-t-24">
          <button mat-flat-button color="primary" class="m-r-8" type="submit" [disabled]="!profileForm.valid">
            {{ "profile_image.upload" | translate }}
          </button>
          <button mat-stroked-button color="warn" (click)="resetProfileImage()">{{ "profile_image.reset" | translate }}</button>
        </div>
        <span class="f-s-14 m-t-24 d-block">{{ "profile_image.allowed_file" | translate }}</span>
      </form>
    </div>
  </mat-card-content>
</mat-card>
